import { IDashbboardResponse } from "../../../../model/publication-shipment/response/dashboard-response";


export type DashboardState = {
  dashboardResponse?: IDashbboardResponse;
};

export enum ACTION_TYPES {
  setDashboardResponse = 'setDashboardResponse'
}

export const DashboardReducer = (state: DashboardState, action: any): DashboardState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setDashboardResponse:
      return {
        ...state,
        dashboardResponse: payload,
      };

    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}